export const PERMISSIONS = {
    CCM_VIEW: 'CCM.VIEW',
    CCM_UPDATE: 'CCM.UPDATE',
    PATIENT_ASSIGNMENT_MANAGE: 'PATIENT_ASSIGNMENT.MANAGE',
    WEEKEND_DISCHARGE_VIEW: 'WEEKEND_DISCHARGE.VIEW',
    LLOS_UPSERT_NOTE: 'LLOS.UPSERT_NOTE',
    LLOS_NOTIFICATION_RECEIVE: 'LLOS_NOTIFICATION.RECEIVE',
    MEETING_VIEW_VIEW: 'MEETING_VIEW.VIEW',
    MEETING_VIEW_SETTINGS_UPDATE: 'MEETING_VIEW_SETTINGS.UPDATE',
    STICKY_NOTES_UPSERT: 'STICKY_NOTES.UPSERT',
    SCORECARD_VIEW: 'SCORECARD.VIEW',
    INSIGHTS_VIEW: 'INSIGHTS.VIEW',
    DART_REPORT_VIEW: 'DART_REPORT.VIEW',
    DART_REPORT_DOWNLOAD: 'DART_REPORT.DOWNLOAD',
    DART_SUBSCRIBERS_MANAGE: 'DART_SUBSCRIBERS.MANAGE',
    CENSUS_VIEW: 'CENSUS.VIEW',
    CENSUS_COVERAGE_PATIENT_MANAGE: 'CENSUS_COVERAGE_PATIENT.MANAGE',
    STAFF_MANAGE: 'STAFF.MANAGE',
    MEETING_REPORT_SUBSCRIBERS_MANAGE: 'MEETING_REPORT_SUBSCRIBERS.MANAGE',
    MEETING_TRANSCRIPTION_MANAGE: 'MEETING_TRANSCRIPTION.MANAGE',
    ACL_MANAGE: 'ACL.MANAGE',
    ESCALATION_DASHBOARD_VIEW: 'ESCALATION_DASHBOARD.VIEW'
} as const;

export const STATIC_SUBSCRIBER_PERMISSIONS = [PERMISSIONS.DART_SUBSCRIBERS_MANAGE, PERMISSIONS.MEETING_REPORT_SUBSCRIBERS_MANAGE] as const;

/** Patient workspace is opened from census, meeting view, CCM, and assignment. */
export const PATIENT_DETAILS_PERMISSIONS = [
    PERMISSIONS.CENSUS_VIEW,
    PERMISSIONS.MEETING_VIEW_VIEW,
    PERMISSIONS.CCM_VIEW,
    PERMISSIONS.PATIENT_ASSIGNMENT_MANAGE
] as const;

/** True when `permissions` includes a key such as `CENSUS.VIEW`. */
export const hasPermission = (permissions: readonly string[] | null | undefined, permission: string): boolean =>
    (permissions ?? []).includes(permission);

/** True when every key is present. */
export const hasAllPermissions = (permissions: readonly string[] | null | undefined, keys: readonly string[]): boolean =>
    keys.every((key) => hasPermission(permissions, key));

/** True when at least one key is present. */
export const hasAnyPermission = (permissions: readonly string[] | null | undefined, keys: readonly string[]): boolean =>
    keys.some((key) => hasPermission(permissions, key));
